import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { BarcodeApiResponse, GenerateBarcodeRequest } from './types';

export class BarcodeApiClient extends ApiClient {
  private readonly _barcodeApiBaseUrl: string | undefined;

  constructor(barcodeApiBaseUrl: string) {
    super();
    this._barcodeApiBaseUrl = barcodeApiBaseUrl;
  }

  generateBarcode = async (request: GenerateBarcodeRequest): Promise<ApiResponse<BarcodeApiResponse | null>> => {
    if (!this._barcodeApiBaseUrl) throw new Error('Barcode API base URL is not defined');

    const params = new URLSearchParams({
      type: String(request.type ?? 'CODE_128'),
      value: String(request.data),
      width: String(request.width ?? 250),
      height: String(request.height ?? 100),
    });

    const { data, statusCode, error } = await this._fetch<BarcodeApiResponse>({
      path: `${this._barcodeApiBaseUrl}?${params}`,
      method: 'GET',
    });

    if (error) {
      return { error, statusCode };
    }

    return { data, statusCode };
  };
}
